import React, { useCallback } from "react";
import {
    buildTransactionRefLabel,
    TransactionReference,
} from "@common/schemas/transactionReference.schema";
import { TransactionsIcon } from "@icons";
import { useTransactionRefContextMaybe } from "@components/tasks/TransactionRefContext";
import { RefChip, RefChipProps } from "./RefChip";
import { useRefChipHoverFocus } from "./useRefChipHoverFocus";
import { useTransactionReferenceDrawer } from "./useTransactionReferenceDrawer";

interface TransactionRefChipProps extends Omit<RefChipProps, "icon" | "label"> {
    reference: TransactionReference;
}

export const TransactionRefChip: React.FC<TransactionRefChipProps> = React.memo(
    function TransactionRefChip({ reference, ...handlers }) {
        return (
            <RefChip
                icon={TransactionsIcon}
                label={reference.label ?? buildTransactionRefLabel(reference)}
                {...handlers}
            />
        );
    },
);

export const MessageTransactionRefChip: React.FC<{
    reference: TransactionReference;
}> = React.memo(function MessageTransactionRefChip({ reference }) {
    const trxRefCtx = useTransactionRefContextMaybe();
    const openDrawer = useTransactionReferenceDrawer();

    const { handleMouseEnter, handleMouseLeave } = useRefChipHoverFocus({
        id: reference.transactionId,
        setFocusedId: trxRefCtx?.setFocusedTransactionId,
    });

    const handleClick = useCallback(() => {
        openDrawer([reference]);
    }, [openDrawer, reference]);

    return (
        <TransactionRefChip
            reference={reference}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
        />
    );
});
